import { AnyAction } from "@reduxjs/toolkit";
import _get from "lodash/get";
import * as AT from "./actionTypes";
import { ShopAvailabilityState } from "../../../../models/state";
import { fulfilled } from "../../app/utils";
import * as CHECKOUT_AT from "../../checkout/state/actionTypes";

const initialState: ShopAvailabilityState = {
    shops: {},
};

const reducer = (state = initialState, action: AnyAction): ShopAvailabilityState => {
    switch (action.type) {
        case fulfilled(AT.SHOP_PICKER_FETCH_SHOP_AVAILABILITY):
            return {
                ...state,
                shops: action.payload,
            };
        case fulfilled(CHECKOUT_AT.CHECKOUT_FETCH_DELIVERY_AND_PAYMENT_METHODS):
            return {
                ...state,
                shops: _get(action, "payload.delivery.shops", {}),
            };
        default:
            return state;
    }
};

export default reducer;
